export default __webpack_public_path__ + "static/media/chilled.6fe4f541.png";